/* eslint-disable object-curly-newline */
/* eslint-disable no-void */
/* eslint-disable arrow-body-style */
/* eslint-disable no-console */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable operator-linebreak */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable no-alert */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-return-assign */
/* eslint-disable max-len */

import { currentDate, DateFormats, diffDay, parseJSDate } from "../datetime";

export interface InfoItem {
    messageId: string;
    startDateStr: string;
    title: string;
    message: string;
    whatsNew?: boolean;
}

/**
 * 7日以内をnewとする
 * @param date
 * @returns true: 7日以内, false: 8日以上
 */
export const isNew = (date: string) => {
    const targetDate = parseJSDate(date, DateFormats.YYYYMMDDHHMM);
    const today = currentDate();
    const diffDays = diffDay(today, targetDate!);
    return diffDays <= 7 && diffDays >= 0;
};
